export default "__VITE_ASSET__chhttvzI__"